import React, { Component } from "react";

import '../../style/category.css';
import '../../style/generic.css';
import HeroSectionCategory from "../Herosection/HeroSectionCategory.js";
import {  Link, useParams } from "react-router";
import * as Constanti from '../../Utils/constants.js';
import axios from "axios";
import CardTwo from "../cards/cardTwo.js";
import AdsCarousel from "../home/sliderAds.js";
import DiretteHome from "../home/diretteHome.js";
import DiretteCategorie from "./diretteCategorie.js";
import { Card } from "react-bootstrap";
import YoutubeClass from "../youtube/youtube.js";

class DettaglioCategoria extends Component{
  constructor(props){
    
    super(props);
    this.state = {
      dirette:[],
      video: [],
      titolo:"",
      "descrizione":"",
      "img":"",
      "page":1,
       videoId:null,
      "lastpage":1,


      }
      this.caricaAltriVideo = this.caricaAltriVideo.bind(this);
  
}

  componentDidMount(){
       this.fetchData(this.props.params.id);
   
  }

componentDidUpdate(prevProps) {
  if (prevProps.params.id !== this.props.params.id) {
    this.setState(
      { video: [], page: 1, titolo: "", descrizione: "", img: "" },
      () => this.fetchData(this.props.params.id) // fetch dopo il reset
    );
  }
}

   fetchData(id) {
  const apiBaseUrl = Constanti.url_Backend + "getVideoByCategoryDetail";
  const payload = {
    id_categoria: id,
    page: 1,
    per_page: 8
  };

  this.setState({ load: true });

  axios.post(apiBaseUrl, payload)
    .then(response => {
      if (response.data.data != null) {
        const location = response.data.data;
        const first = location.data[0]?.categorie;

        this.setState({
          video: location.data,
          titolo: first?.description || "",
          descrizione: first?.descrizione || "",
          img: first?.thumbnail || "",
          load: false
        });
      } else {
        console.log("non ci sono video per questo id");
        this.setState({ video: [], load: false });
      }
    })
    .catch(error => {
      console.error(error);
      this.setState({ load: false });
    });
 const apiBaseUrlDir = Constanti.url_Backend + "getDirettabyCategory";
  const payloadDir = {
    id_categoria: id,
  };
    axios.post(apiBaseUrlDir, payloadDir)
    .then(response => {
      if (response.data.data != null) {
        const data = response.data.data;
        this.setState({
          dirette: data
        });
      } else {
        console.log("non ci sono dirette per questa categoria");
      }
    })
    .catch(error => {
      console.error(error);
    });
}

chiudiModal = (e) => {
    this.setState({ videoId: null });
  };

 showVideo = (id) => {
    this.setState({ videoId: id });
  };

  caricaAltriVideo(){
    const apiBaseUrl = Constanti.url_Backend + "getVideoByCategoryDetail";
    const nextPage   = this.state.page + 1;
    const payload    = {
      id_categoria: this.props.params.id,
      page:         nextPage,
      per_page:     8
    };
  
    this.setState({ load: true });
  
    axios.post(apiBaseUrl, payload)
      .then(response => {
        const location = response.data.data;       // la paginazione
        const newVideos = location.data || [];   
        const { data, last_page } = response.data.data;  // l’array dei video
  
        if (newVideos.length > 0) {
          // uso la forma funzionale di setState
          this.setState(prev => ({
            page:  nextPage,
            video: [...(prev.video || []), ...newVideos],
            load:  false,
            lastpage: last_page

          }));
        } else {
          console.log("non ci sono video per questo id");
          this.setState({ load: false });
        }
      })
      .catch(error => {
        console.error(error);
        this.setState({ load: false });
      });
  }


  render(){
    const {titolo,descrizione,img,video,dirette,videoId,page,lastpage} = this.state;
    return (
    <>
  <HeroSectionCategory titolo={titolo} descrizione={descrizione} img={img}></HeroSectionCategory>
     <AdsCarousel color="scuro" centro="true"></AdsCarousel>
      
  <section className="categoryDetail">
  {dirette != null && dirette.length>0 &&
      <DiretteCategorie name="Live ora" lista={dirette} onShowVideo={this.showVideo}/>
       }
  <div className={`container ${dirette == null || dirette.length == 0 ? 'padding-top-48' : ''}`}>
  <div className="slider-title-wrapper " id="anchor">
   <h2 className="h2">Titti i video</h2>
  </div>
   <div className="grid padding-top-16 padding-bottom-80">
  {video != null && video?.map(el => (
      <div className="contenitoreCard" key={"catDet"+el.id}>
      <Link to={'/video/'+el.id}>
    <CardTwo thumbnail={el.thumbnail} title={el.title} data={el.created_at} isCat="true"></CardTwo>
    </Link>
    </div>
    ))}
    </div>
      { page < lastpage &&
    <div className="carica-altri padding-top-48 padding-bottom-48 ">
     <div onClick={this.caricaAltriVideo} className="caricaAltri button secondary small w-button cursor-pointer">Carica altri</div>
    </div>
      }
    </div>
 </section>
  {videoId && (
      <div className="modal" id="myModal">
        <div className="modal-content">
          <span className="close" id="closeModal" onClick={this.chiudiModal}>&times;</span>
          <YoutubeClass videoId={videoId} />
        </div>
    </div>
        )}
</>
    )
}
}

export default (props) => (
  <DettaglioCategoria
      {...props}
      params={useParams()}
  />);